// extracted by mini-css-extract-plugin
module.exports = {"component":"logo-feature-list_component__GkyPI","feature":"logo-feature-list_feature__XwvUU","icon":"logo-feature-list_icon__PE5X5","text":"logo-feature-list_text__t_jWO"};